import * as config from '../../package.json';

const {versionAPI, versionClient} = config;
const ABOUT = {version: versionClient, versionAPI};

export default ABOUT;
